<template>
  <div class="contact">
    <div class="contact-title">
      <div class="left"></div>
      <div class="text">{{ $t('transaction.place.contact') }}</div>
      <div class="right"></div>
    </div>
    <div class="contact-icon">
      <img src="/transaction/contact_icon1.png" />
      <img src="/transaction/contact_icon2.png" />
      <img src="/transaction/contact_icon3.png" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.contact {
  margin-top: 45px;
  padding-bottom: 216px;
  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    .left,
    .right {
      width: 80px;
      height: 1px;
      background: #d9d9d9;
    }
    .text {
      font-family: 'PingFang TC';
      font-weight: 600;
      font-size: 14px;
      margin: 0 15px;
    }
  }
  &-icon {
    text-align: center;
    margin-top: 10px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 13px;
    }
  }
}
</style>
